module.exports = __webpack_public_path__ + "img/jinniao_icon06.1d92b012.png";